module.exports = __webpack_public_path__ + "img/other.929b4ffa.png";